<template>
    <Breadcrumbs main="Search Pages" title="Search Website" />
    <div class="container-fluid search-page">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <searchBar />
                    <searchTab />
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const searchBar = defineAsyncComponent(() => import("@/components/theme/search/searchBar.vue"))
const searchTab = defineAsyncComponent(() => import("@/components/theme/search/searchTab.vue"))
</script>